<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Employee Setup</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"
                      ><i data-feather="home"></i
                    ></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item">Setup</li>
                  <li class="breadcrumb-item active">Employee Setup</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12" v-if="isCreate">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Add New Employee</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <!-- <div class="row g-3">
                    <div class="col-md-4">
                      <label class="form-label" for="title">Title</label>
                      <input
                        v-model="title"
                        class="form-control"
                        id="color"
                        type="text"
                        placeholder="Enter Title"
                        aria-describedby="inputGroupPrepend"
                        required
                      />
                    </div>

                    <div class="col-md-4">
                      <label class="form-label" for="status">Price</label>
                      <input
                        v-model="price"
                        class="form-control"
                        id="status"
                        type="text"
                        placeholder="Enter Price"
                        aria-describedby="inputGroupPrepend"
                        required
                      />
                    </div>
                  </div> -->
                  <!-- <button class="btn btn-primary" type="submit" @click="addNew">
                    Add
                  </button> -->

                  <!-- </form> -->
                  <form class="needs-validation" novalidate="">
                    <div class="row g-3">
                      <div class="col-md-4">
                        <label class="form-label" for="name">Employee Name</label>
                        <div class="input-group">
                          <span class="input-group-text" id="inputGroupPrepend">@</span>
                          <input
                            v-model="employee.name"
                            class="form-control"
                            id="color"
                            type="text"
                            placeholder="Employee Name"
                            aria-describedby="inputGroupPrepend"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">Employee Code</label>
                        <input
                          v-model="employee.code"
                          class="form-control"
                          id="color"
                          type="text"
                          placeholder="Employee Code"
                          aria-describedby="inputGroupPrepend"
                          required=""
                        />
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name"
                          >Employee Contact Number</label
                        >
                        <div class="input-group">
                          <span class="input-group-text" id="inputGroupPrepend">+88</span>
                          <input
                            v-model="employee.phone_number"
                            class="form-control"
                            id="color"
                            type="text"
                            placeholder="Employee Number"
                            aria-describedby="inputGroupPrepend"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="color">Email</label>
                        <div class="input-group">
                          <span class="input-group-text" id="inputGroupPrepend">@</span>
                          <input
                            v-model="employee.email"
                            class="form-control"
                            id="color"
                            type="text"
                            placeholder="Employee Email"
                            aria-describedby="inputGroupPrepend"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">Employee Password</label>
                        <input
                          v-model="employee.password"
                          class="form-control"
                          id="color"
                          type="text"
                          placeholder="New Password"
                          aria-describedby="inputGroupPrepend"
                          required=""
                        />
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">Confirm Password</label>
                        <input
                          v-model="employee.confirm_password"
                          class="form-control"
                          id="color"
                          type="text"
                          placeholder="Confirm Password"
                          aria-describedby="inputGroupPrepend"
                          required=""
                        />
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">Employee Address</label>
                        <textarea
                          v-model="employee.address"
                          class="form-control"
                          id="color"
                          type="text"
                          placeholder="Enter Address"
                          aria-describedby="inputGroupPrepend"
                          required=""
                        />
                      </div>
                    </div>
                    <button
                      class="btn btn-primary mt-3"
                      type="button"
                      @click="addEmployeeAction"
                    >
                      Add
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <!-- Update -->
            <div class="col-sm-12 col-lg-12" v-if="!isCreate">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Update Connection</h5>
                </div>
                <div class="card-body">
                  <!-- <div class="row g-3">
                    <div class="col-md-4">
                      <label class="form-label" for="title">Name</label>
                      <input
                        v-model="update.title"
                        class="form-control"
                        id="color"
                        type="text"
                        placeholder="Enter Area Name"
                        aria-describedby="inputGroupPrepend"
                        required
                      />
                    </div>

                    <div class="col-md-4">
                      <label class="form-label" for="status">Price</label>
                      <input
                        v-model="update.price"
                        class="form-control"
                        id="status"
                        type="text"
                        placeholder="Enter Price"
                        aria-describedby="inputGroupPrepend"
                        required
                      />
                    </div>
                  </div>
                  <button class="btn btn-primary" type="submit" @click="updateTypeSubmit">
                    Update
                  </button>
                  <button class="btn btn-danger" type="submit" @click="cancelUpdate">
                    Cancel
                  </button> -->
                  <form class="needs-validation" v-if="!isCreate">
                    <div class="row g-3">
                      <div class="col-md-4">
                        <label class="form-label" for="name">Employee Name</label>
                        <div class="input-group">
                          <span class="input-group-text" id="inputGroupPrepend">@</span>
                          <input
                            v-model="update.name"
                            class="form-control"
                            id="color"
                            type="text"
                            placeholder="Employee Name"
                            aria-describedby="inputGroupPrepend"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">Employee Code</label>
                        <input
                          v-model="update.code"
                          class="form-control"
                          id="color"
                          type="text"
                          placeholder="Employee Code"
                          aria-describedby="inputGroupPrepend"
                          required=""
                        />
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name"
                          >Employee Contact Number</label
                        >
                        <div class="input-group">
                          <span class="input-group-text" id="inputGroupPrepend">+88</span>
                          <input
                            v-model="update.phone_number"
                            class="form-control"
                            id="color"
                            type="text"
                            placeholder="Employee Number"
                            aria-describedby="inputGroupPrepend"
                            required=""
                          />
                        </div>
                      </div>
                      <!-- <div class="col-md-4">
                        <label class="form-label" for="color">Email</label>
                        <div class="input-group">
                          <span class="input-group-text" id="inputGroupPrepend">@</span>
                          <input
                            v-model="update.email"
                            class="form-control"
                            id="color"
                            type="text"
                            placeholder="Employee Email"
                            aria-describedby="inputGroupPrepend"
                            required=""
                          />
                        </div>
                      </div>
                       <div class="col-md-4">
                        <label class="form-label" for="name">Employee Password</label>
                        <input
                          v-model="update.password"
                          class="form-control"
                          id="color"
                          type="text"
                          placeholder="New Password"
                          aria-describedby="inputGroupPrepend"
                          required=""
                        />
                      </div>
                      <div class="col-md-4">
                        <label class="form-label" for="name">Confirm Password</label>
                        <input
                          v-model="update.confirm_password"
                          class="form-control"
                          id="color"
                          type="text"
                          placeholder="Confirm Password"
                          aria-describedby="inputGroupPrepend"
                          required=""
                        />
                      </div> -->
                      <div class="col-md-4">
                        <label class="form-label" for="name">Employee Address</label>
                        <textarea
                          v-model="update.address"
                          class="form-control"
                          id="color"
                          type="text"
                          placeholder="Enter Address"
                          aria-describedby="inputGroupPrepend"
                          required=""
                        />
                      </div>
                    </div>
                    <button
                      class="btn btn-primary"
                      type="button"
                      @click="updateTypeSubmit"
                    >
                      Update
                    </button>
                    <button class="btn btn-danger" type="button" @click="cancelUpdate">
                      Cancel
                    </button>
                  </form>
                </div>
              </div>
            </div>

            <!-- Data table -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                  <span>Service Type</span>
                </div>
                <div class="card-body">
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="employeeListTBL">
                      <thead>
                        <tr align="center">
                          <!-- <th>#</th> -->
                          <th>Name</th>
                          <th>Code</th>
                          <th>Email</th>
                          <th>Phone Number</th>
                          <th>Address</th>
                          <th>Active Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          align="center"
                          v-for="(item, index) in employeeList"
                          :key="index"
                        >
                          <!-- <td>{{ index + 1 }}</td> -->
                          <td>{{ item.name }}</td>
                          <td>{{ item.code }}</td>
                          <td>{{ item.email }}</td>
                          <td>{{ item.phone }}</td>
                          <td>{{ item.address }}</td>
                          <td>
                            <div
                              class="media-body switch-sm"
                              v-if="item.status === 1"
                              @click.prevent="changeStatus(item.user_id)"
                            >
                              <label class="switch">
                                <input type="checkbox" checked /><span
                                  class="switch-state"
                                ></span>
                              </label>
                            </div>
                            <div
                              class="media-body switch-sm"
                              v-if="item.status === 2"
                              @click.prevent="changeStatus(item.user_id)"
                            >
                              <label class="switch">
                                <input type="checkbox" /><span
                                  class="switch-state"
                                ></span>
                              </label>
                            </div>
                          </td>
                          <td>
                            <button
                              class="btn btn-info btn-sm"
                              type="button"
                              data-original-title="btn btn-info btn-sm"
                              title=""
                              @click.prevent="resetPassword(item.user_id)"
                            >
                              Reset
                            </button>
                            <button
                              class="btn btn-danger btn-sm"
                              type="button"
                              data-original-title="btn btn-danger btn-sm"
                              title=""
                              @click.prevent="deleteType(item.user_id)"
                            >
                              Delete
                            </button>
                            <button
                              v-if="item.status === 1 && this.profile_id === item.user_id"
                              class="btn btn-primary btn-sm"
                              type="button"
                              data-original-title="btn btn-danger btn-sm"
                              title=""
                              @click.prevent="updateType(item)"
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import $ from "jquery";
import employeeAPI from "../../services/employee.API";
import userAPI from '../../services/user.API';

export default {
  name: "employeeList",
  components: {},
  data() {
    return {
      title: "",
      price: "",
      employeeList: [],
      districtList: [],
      isCreate: true,

      selectedDistrict: null,
      employee: {
        name: "",
        code: "",
        phone_number: "",
        email: "",
        address: "",
        password: "",
        confirm_password: "",
      },
      update: {
        id: "",
        name: "",
        code: "",
        phone_number: "",
        email: "",
        address: "",
        password: "",
        confirm_password: "",
      },
      profile_id: ''
    };
  },
  methods: {
    // district list
    getList() {
      employeeAPI.getList().then(
        (response) => {
          this.employeeList = response.data.data;
          console.log(response.data.data);
        },
        (err) => {
          if (err.response.data.success === false) {
            this.employeeList = [];
          }
        }
      );
    },
    addEmployeeAction() {
      let data = {
        name: this.employee.name,
        code: this.employee.code,
        phone_number: this.employee.phone_number,
        email: this.employee.email,
        address: this.employee.address,
        password: this.employee.password,
        confirm_password: this.employee.confirm_password,
      };

      employeeAPI
        .createEmployeeUser(data)
        .then((response) => {
          this.$moshaToast(response.data.message, {
            type: "success",
            position: "top-right",
            showIcon: true,
          });
          // get all connection type
          employeeAPI.getList().then((response) => {
            this.employeeList = response.data.data;
          });
          this.employee = {};
        })
        .catch((error) => {
          // console.log(error.response.data.success);
          if (error.response.data.success === false) {
            this.$moshaToast(error.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        });
    },
    // addNew
    // addNew() {
    //   //   console.log(this.title, this.status);
    //   if (this.title == "") {
    //     this.$moshaToast("Please enter Area title", {
    //       type: "danger",
    //       position: "top-right",
    //       showIcon: true,
    //     });
    //   } else if (this.price == "") {
    //     this.$moshaToast("Please enter price", {
    //       type: "danger",
    //       position: "top-right",
    //       showIcon: true,
    //     });
    //   } else {
    //     let data = {
    //       actual_price: this.price,
    //       title: this.title,
    //     };
    //     employeeAPI
    //       .createServiceType(data)
    //       .then((response) => {
    //         this.$moshaToast(response.data.message, {
    //           type: "success",
    //           position: "top-right",
    //           showIcon: true,
    //         });
    //         // get all connection type
    //         employeeAPI.getList().then((response) => {
    //           this.employeeList = response.data.data;
    //         });
    //         this.title = "";
    //         this.price = "";
    //       })
    //       .catch((error) => {
    //         // console.log(error.response.data.success);
    //         if (error.response.data.success === false) {
    //           this.$moshaToast(error.response.data.message, {
    //             type: "danger",
    //             position: "top-right",
    //             showIcon: true,
    //           });
    //         }
    //       });
    //   }
    // },

    // delete
    deleteType(id) {
      if (id) {
        employeeAPI.deleteEmployee(id).then((response) => {
          this.$moshaToast(response.data.message, {
            type: "success",
            position: "top-right",
            showIcon: true,
          });
          // get all connection type
          employeeAPI.getList().then((response) => {
            this.employeeList = response.data.data;
          });
        });
      } else {
        this.$moshaToast("Please select service type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },

    // change status
    changeStatus(id) {
      if (id) {
        employeeAPI.changeStatus(id).then((response) => {
          this.$moshaToast(response.data.message, {
            type: "success",
            position: "top-right",
            showIcon: true,
          });
          // get all connection type
          employeeAPI.getList().then((response) => {
            this.employeeList = response.data.data;
          });
        });
      } else {
        this.$moshaToast("Please select connection type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },

    // update
    updateType(item) {
      this.isCreate = false;
      //   this.title = item.title;
      //   this.status = item.status === 1 ? true : false;
      this.id = item.id;
      // console.log(this.update);
      this.update.id = item.id;
      this.update.name = item.name;
      this.update.code = item.code;
      //   this.update.email = item.email;
      this.update.phone_number = item.phone;
      this.update.address = item.address;
    },

    // cancelUpdate
    cancelUpdate() {
      this.isCreate = true;
      this.update = {};
    },

    // update submit
    updateTypeSubmit() {
      if (this.update.name == "") {
        this.$moshaToast("Please enter Name", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      } else if (this.update.phone_number == "") {
        this.$moshaToast("Please enter Number", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      } else {
        // console.log(this.update);
        let data = {
          id: this.update.id,
          name: this.update.name,
          phone_number: this.update.phone_number,
          address: this.update.address,
        };
        employeeAPI
          .updateEmployee(data)
          .then((response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get all connection type
            employeeAPI.getList().then((response) => {
              this.employeeList = response.data.data;
            });
            this.isCreate = true;
            this.update = {};
          })
          .catch((error) => {
            // console.log(error.response.data.success);
            if (error.response.data.success === false) {
              this.$moshaToast(error.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          });
      }
    },
    resetPassword(id) {
      employeeAPI
        .resetPassword(id)
        .then((response) => {
          this.$moshaToast(response.data.message, {
            type: "success",
            position: "top-right",
            showIcon: true,
          });
        })
        .catch((error) => {
          // console.log(error.response.data.success);
          if (error.response.data.success === false) {
            this.$moshaToast(error.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        });
    },
  },
  mounted() {
    console.log(this.$store.state.profile);
    //   list
    employeeAPI.getList().then((response) => {
      this.employeeList = response.data.data;
      setTimeout(() => {
        $("#employeeListTBL").DataTable({
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, "All"],
          ],
          pageLength: 10,
          info: false,
          targets: "no-sort",
          bSort: false,
          order: [],
          bFilter: true,
          bInfo: false,
          //   bLengthChange: false,
          bDestroy: true,
        });
      });
    });

    // me api
    userAPI.getUserProfile().then((response) => {
          if(response?.data?.data){
            // console.log(response?.data?.data)
            this.profile_id = response?.data?.data?.user_id
          }
        }
      )
  },
  computed: {
    getUserProfileRole() {
      console.log(this.$store.state.profile);
      return this.$store.state.profile;
    },
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}
th {
  text-align: center !important;
}
span.switch-state:before {
    background: #000!important;
    margin-bottom: -2px!important;
}
span.switch-state {
  border: 2px solid #000!important;
}
</style>
